import React from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";

const Home = ({ projects }) => {
  const navigate = useNavigate();

  const navigateToPage = (navigateTo) => {
    navigate(navigateTo);
  };
  return projects.map((z) => (
    <>
      <div className="project">
        <div
          className="overlay"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            navigateToPage(`${z.title + z.index}`);
          }}
        ></div>
        <video
          className="video-full"
          autoPlay
          loop
          muted
          disablePictureInPicture
          webkit-playsinline
          playsinline
          poster={z.videoThumbnail}
          // onClick={() => {
          //   window.scrollTo({ top: 0, left: 0, behavior: "instant" });
          //   navigateToPage(`${z.title + z.index}`);
          // }}
        >
          <source src={z.videoPreviewUrl} type="video/mp4" />
        </video>
        <div className="project-title">
          {z.category} ⸺ {z.title}
        </div>
      </div>
      {/* <div className="separator"></div> */}
    </>
  ));
};

export default Home;
